import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'shared/Spinner';
import KioskPaymentIcon from './KioskPaymentIcon';
import FormattedCurrency from '@s/FormattedCurrency';
import Translation from '@s/Translation';

class KioskCardReader extends Component<Props> {

    state = {
        total: null,
    };

    componentDidMount() {
        this.setState({ total: this.props.total });
    }

    render() {
        return (
            <div className="kisok-payment__cc-steps">
                {this.state.total && this.state.total.amount && <div className="kiosk-payment__cc-step__total">
                    <FormattedCurrency>{this.state.total.amount}</FormattedCurrency>
                </div>}
                <div className="kiosk-payement__cc-step-text">
                    {this.renderText()}
                </div>
                <div className="kiosk-payement__cc-step-icon">
                    {this.renderIcon()}
                </div>
            </div>
        )
    }

    renderText = () => {
        if (this.props.error) {
            return <span className="kiosk-text-theme">{this.props.error}</span>;
        } else if (this.props.loading) {
            return <span className="kiosk-text-theme"><Translation>{'checkout__processing'}</Translation></span>;
        } else {
            return <span className="kiosk-text-theme"><Translation>{'checkout__swipe_insert_card_reader'}</Translation></span>
        }
    }

    renderIcon = () => {
        if (this.props.error) {
            return <KioskPaymentIcon />;
        } else if (this.props.loading) {
            return <Spinner />;
        } else {
            return <KioskPaymentIcon />;
        }
    }
}

KioskCardReader.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
};

export default KioskCardReader

